import * as types from "../actions/actionTypes"
const initialState = {
    loading:true,
    provinces: [],
    province_cities:[]
};

const Province = (state = initialState, action) =>{
    switch (action.type) {
        case types.PROVINCE_REQUEST:
            return {...state,loading: true};
        case types.PROVINCE_SUCCESS:
            return { ...state, ...action.payLoad,loading: false };
        case types.PROVINCE_FAILURE:
            return { ...state, loading: false };

        case types.CITY_REQUEST:
            return {...state,loading: true};
        case types.CITY_SUCCESS:
            return { ...state, ...action.payLoad,loading: false };
        case types.CITY_FAILURE:
            return { ...state, loading: false };
        case types.CITY_CLEAN_LIST:
            return{...state,province_cities:[]};
        default:
            return state;
    }
};

export default Province;
